export default {
  Syncing: 'syncing',
  Synced: 'synced',
  Error: 'error',
};
